export let Code = {
type: `@Component({
    selector: 'p-messages',
    template:
        <p-messages [(value)]="msgs"></p-messages>

        <h3 class="first">Basic</h3>
        <div>
            <button type="button" pButton (click)="showSuccess()" label="Success" class="ui-button-success"></button>
            <button type="button" pButton (click)="showInfo()" label="Info" class="ui-button-info"></button>
            <button type="button" pButton (click)="showWarn()" label="Warn" class="ui-button-warning"></button>
            <button type="button" pButton (click)="showError()" label="Error" class="ui-button-danger"></button>
            <button type="button" pButton (click)="showMultiple()" label="Multiple"></button>
            <button type="button" pButton (click)="clear()" icon="fa-close" style="float:right" label="Clear"></button>
        </div>

        <h3>Message Service</h3>
        <button type="button" pButton (click)="showViaService()" label="Use Service"></button>

        <h3>Inline Message CSS</h3>
        <p>CSS helpers to display inline messages mostly within forms.</p>
        <p-message severity="info" text="PrimeNG Rocks"></p-message>
        <p-message severity="success" text="Record Saved"></p-message>  
        <p-message severity="warn" text="Are you sure?"></p-message>  
        <p-message severity="error" text="Field is required"></p-message>

        <div style="margin-top:30px">
            <input type="text" pInputText placeholder="Username" class="ng-dirty ng-invalid">
            <p-message severity="error" text="Field is required"></p-message>
        </div>

        <div style="margin-top:30px">
            <input type="text" pInputText placeholder="Email" class="ng-dirty ng-invalid">
            <p-message severity="error"></p-message>
        </div>
})
export class Messages {

}
`
};


// WEBPACK FOOTER //
// ./src/app/code/messages.ts